module.exports = __webpack_public_path__ + "static/media/4-11.9ecc4623.png";